import TablePlayerAvatar from "../../../../table/components/table_player_avatar";
import ComponentBase from "../../../../public/component/component_base";


const {ccclass, property} = cc._decorator;

@ccclass
export default class BullPlayerInfoNode extends ComponentBase {

    @property(TablePlayerAvatar)
    avatarCom : TablePlayerAvatar;

    @property(cc.Node)
    nobody : cc.Node = null;

    private playerId : number;

    onEnable(){
        
        //this.showAvatar(false);

        this.nobody.active = true;
    }


    onDisable(){

        this.playerId = 0;
    }


    // updateAvatar(playerId : number){

    //     this.playerId = playerId;
    //     this.avatarCom.show(true,playerId);
    // }

    updateBalance(balance : number){

        this.avatarCom.refreshCoinBalance(balance);
    }

    updateName(name : string){
        
        this.avatarCom.refreshName(name);
    }

    showAvatar(show:boolean,playerId ? : number){

        this.avatarCom.show(show,playerId);

        this.nobody.active = !show;

        // if (!show) {
        //     //将头像清空
        //     this.avatarCom.refreshAvatar(null);            
        // }
    }

    showMask(show : boolean){

        this.avatarCom.showMask(show);
    }

    get avatarMidNode(){

        return this.avatarCom.midNode;
    }



}
